import Abstract from "../../../abstract-view/abstract.js";

export default class Section extends Abstract {
  constructor(element) {
    super();

    this._element = element;

    this._productsElement = null;
    this._paginationElement = null;
    this._paginationWrapperElement = null;
    this._sortingListElement = null;
    this._categoriesElement = null;
    this._actionsWrapper = null;
    this._headingElement = null;
  }

  getProductsElement() {
    this._productsElement = this._element.querySelector(`.products-list`);
    return this._productsElement;
  }

  updateProductsElement(element) {
    this._productsElement = element;
  }

  getPaginationElement() {
    this._paginationElement = this._element.querySelector(`.pagination`);
    return this._paginationElement;
  }

  getPaginationWrapperElement() {
    this._paginationWrapperElement = this._element.querySelector(`.pagination-wrapper`);
    return this._paginationWrapperElement;
  }

  getSortingListElement() {
    if (!this._sortingListElement) {
      this._sortingListElement = this._element.querySelector(`.sorting-list`);
    }

    return this._sortingListElement;
  }

  getCategoriesElement() {
    this._categoriesElement = this._element.querySelector(`.select_categories`);
    return this._categoriesElement;
  }

  getActionsWrapper() {
    if (!this._actionsWrapper) {
      this._actionsWrapper = this._element.querySelector(`.sorting-categories-wrapper`);
    }

    return this._actionsWrapper;
  }

  getHeadingElement() {
    if (!this._headingElement) {
      this._headingElement = this._element.querySelector(`h1`);
    }

    return this._headingElement;
  }
}
